import type { BookingListFilters, LessonListFilters } from './keys';

/** Shared empty filter objects — avoids new `{}` per render breaking query keys and useMemo. */
export const EMPTY_LESSON_FILTERS: LessonListFilters = {};
export const EMPTY_BOOKING_FILTERS: BookingListFilters = {};

/** Stable serialization for filter objects used in useMemo / query keys. */
export function serializeFilters(filters: object): string {
  const record = filters as Record<string, unknown>;
  const keys = Object.keys(record).sort();
  if (keys.length === 0) return '';
  return JSON.stringify(record, keys);
}
